import React from "react";
import { Box, Stack, Typography } from "../";

interface AssignedDriverType {
  data: Driver;
  info?: React.ReactNode;
}
interface Driver {
  id: number;
  first_name: string;
  last_name: string;
}

function AssignedDriver(props: AssignedDriverType) {
  return (
    <Box style={{ width: "100%" }} br="m" p="l" bg="common.white">
      <Stack distribution="space-between">
        <Stack>
          <Box>
            <Typography color="text.light950" fs="s">
              سفیر شما
            </Typography>
            <Typography ff="mainBold">
              {props.data.first_name} {props.data.last_name}
            </Typography>
          </Box>
        </Stack>
        {props.info}
      </Stack>
    </Box>
  );
}

export default AssignedDriver;
